__turbopack_context__.v({
  "className": "poppins_692bffda-module__OPRxXW__className",
  "variable": "poppins_692bffda-module__OPRxXW__variable",
});
